var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"ml-2",attrs:{"size":"18","color":"orange"}},on),[_vm._v(" $vuetify.icons.statusWarning ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('configManager.changingRequiresRestart')))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }